"use client"

import type React from "react"

import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog"
import { Button } from "../../../components/ui/button"
import { Input } from "../../../components/ui/input"
import { Label } from "../../../components/ui/label"
import { X } from "lucide-react"
import type { Project } from "./clients-modal"

interface AddProjectDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (project: Omit<Project, "id">) => void
}

export function AddProjectDialog({ open, onOpenChange, onAdd }: AddProjectDialogProps) {
  const [formData, setFormData] = useState({
    thumb: "",
    orderNumber: "",
    name: "",
    phone: "",
    email: "",
    city: "",
    orderList: [] as string[],
    sport: "",
    order: [] as any
  })
  const [currentOrder, setCurrentOrder] = useState("")

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    // Validação básica
    if (!formData.name || !formData.orderNumber) {
      alert("Nome e número do pedido são obrigatórios")
      return
    }

    onAdd(formData)

    // Limpa o formulário
    setFormData({
      thumb: "",
      orderNumber: "",
      name: "",
      phone: "",
      email: "",
      city: "",
      orderList: [],
      sport: "",
      order: []
    })
    setCurrentOrder("")
  }

  const handleAddOrder = () => {
    if (currentOrder.trim()) {
      setFormData({
        ...formData,
        orderList: [...formData.orderList, currentOrder.trim()],
      })
      setCurrentOrder("")
    }
  }

  const handleRemoveOrder = (index: number) => {
    setFormData({
      ...formData,
      orderList: formData.orderList.filter((_, i) => i !== index),
    })
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault()
      handleAddOrder()
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Adicionar Novo Projeto</DialogTitle>
          <DialogDescription>Preencha os dados do novo projeto</DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="orderNumber">
                Número do Pedido <span className="text-destructive">*</span>
              </Label>
              <Input
                id="orderNumber"
                placeholder="#001"
                value={formData.orderNumber}
                onChange={(e) => setFormData({ ...formData, orderNumber: e.target.value })}
                required
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="name">
                Nome <span className="text-destructive">*</span>
              </Label>
              <Input
                id="name"
                placeholder="João Silva"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="phone">Telefone</Label>
              <Input
                id="phone"
                placeholder="(11) 98765-4321"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="joao@email.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="city">Cidade</Label>
              <Input
                id="city"
                placeholder="São Paulo"
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e.target.value })}
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="thumb">URL da Imagem</Label>
              <Input
                id="thumb"
                placeholder="/projeto.jpg ou https://..."
                value={formData.thumb}
                onChange={(e) => setFormData({ ...formData, thumb: e.target.value })}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="orderItem">Lista de Pedidos</Label>
            <div className="flex gap-2">
              <Input
                id="orderItem"
                placeholder="Digite um item e pressione Enter"
                value={currentOrder}
                onChange={(e) => setCurrentOrder(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <Button type="button" onClick={handleAddOrder} variant="secondary">
                Adicionar
              </Button>
            </div>

            {/**{formData.orderList.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-2 p-3 bg-muted rounded-md">
                {formData.orderList.map((order, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-1 bg-background px-3 py-1 rounded-md text-sm border"
                  >
                    <span>{order}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveOrder(index)}
                      className="ml-1 hover:text-destructive"
                    >
                      <X className="h-3 w-3" />
                    </button>
                  </div>
                ))}
              </div>
            )} */}
          </div>

          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button type="submit">Adicionar Projeto</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
